import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../globals/core/Breadcrumbs/Breadcrumb";
import DatatableTables from "../../globals/core/Tables/DatatableTables";
import { useDispatch } from "react-redux";
import { showLoader } from "../../store/actions/mainActions";
import { SystemLogsService } from "../../globals/services/systemLogs.service";
import moment from "moment";

export const SystemLogs = (props) => {
  // const { activities } = useSelector((state) => state.activities);
  // const activities = [];
  const [logs, setLogs] = useState([]);
  const dispatch = useDispatch();

  const columns = [
    {
      dataField: "status",
      text: "STATUS",
    },
    {
      dataField: "action",
      text: "ACTION",
      sort: true,
    },
    {
      dataField: "start",
      text: "START TIME",
      sort: true,
      formatter: (cell) => {
        return moment(new Date(parseInt(cell))).format("DD/MM/YYYY hh:mm")
      },
    },
    {
      dataField: "end",
      text: "END TIME",
      sort: true,
      formatter: (cell) => {
        return moment(new Date(parseInt(cell))).format("DD/MM/YYYY hh:mm")
      },
    },
    {
      dataField: "errorMessage",
      text: "ERROR MESSAGE",
      sort: true,
    },
  ];

  useEffect(() => {
    const getActivities = async () => {
      try {
        dispatch(showLoader(true));
        const systemLogsService = SystemLogsService();
        const _logs = await systemLogsService.get();
        setLogs(_logs);
        dispatch(showLoader(false));
      } catch (err) {
        dispatch(showLoader(false));
        console.error(err);
      }
    };
    getActivities();
  }, [setLogs, dispatch]);

  const filterToTooltips = () => {
    const items = [...logs.map((c) => ({ ...c }))];
    let tableIndex = 0;
    return items.map((i) => {
      i["tableIndex"] = tableIndex;
      //   for (let prop in i) {
      //     if (typeof i[prop] === 'string')
      //       i[prop] = <TooltipStatement
      //         shorten={truncate(i[prop], 30, '...')}
      //         statement={i[prop]}
      //       />
      //   }
      tableIndex++;
      return i;
    });
  };

  return (
    <div className="content">
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="MAIN" breadcrumbItem="HARTMAN SYSTEM LOGS" />
          <DatatableTables
            columns={columns}
            data={filterToTooltips()}
            title={"System Logs"}
            desc={"Recent Items"}
            // rowEvents={rowEvents}
          ></DatatableTables>
        </div>
      </div>
    </div>
  );
};
